import React from 'react';
import InfoText from '../atoms/InfoText';

export default function CardWrapper({
  title,
  children,
}: {
  title: string;
  children: React.ReactElement;
}) {
  return (
    <div
      className={`bg-soft-background rounded-xl px-6 py-4 border flex flex-col gap-y-2`}
    >
      <InfoText text={title} className="font-bold text-lg" />

      {children}
    </div>
  );
}
